/** What the builder's preview prints for each variable; typed so a new variable needs one. */
export const VARIABLE_SAMPLES = {
    'user.username': 'alex',
    'user.identityName': 'Alex Rivera',
    'session.mediaTitle': 'Fish',
    'session.mediaType': 'episode',
    'session.sourceDynamicRange': 'Dolby Vision',
    'session.sourceVideoCodec': 'hevc',
    'session.seasonNumber': '1',
    'session.episodeNumber': '6',
    'session.name': 'The Bear S01 · E06',
    'server.name': 'Basement',
    'server.type': 'plex',
    durationMinutes: '42',
    minutes: '30',
    days: '45',
    'device.name': 'Living Room TV',
    'device.platform': 'Roku',
    'device.product': 'Plex for Roku',
    'device.location': 'Denver, US',
    'trust.previous': '90',
    'trust.new': '40',
    'trust.reason': 'Sharing penalty',
    'media.title': 'Dune: Part Two',
    'media.name': 'Dune: Part Two',
    'media.show': 'The Bear',
    'media.season': '1',
    'media.episode': '6',
    'media.episodeCount': '3',
    'media.type': 'movie',
    'media.year': '2024',
    'media.library': 'Movies',
    'media.server': 'Basement',
    'media.from.resolution': '1080p',
    'media.to.resolution': '4K',
    'media.from.dynamicRange': 'SDR',
    'media.to.dynamicRange': 'HDR10',
    'media.from.videoCodec': 'h264',
    'media.to.videoCodec': 'hevc',
    'media.from.audioCodec': 'aac',
    'media.to.audioCodec': 'truehd',
    'media.from.audioChannels': '2.0',
    'media.to.audioChannels': '7.1',
    'media.from.fileSize': '8.2 GB',
    'media.to.fileSize': '61.4 GB',
    installedVersion: '2.5.1',
    latestVersion: '2.5.2',
    downloadUrl: 'https://github.com/connorgallopo/Tracearr/releases',
    releaseUrl: 'https://github.com/connorgallopo/Tracearr/releases',
    'newsletter.name': 'Weekly digest',
    'newsletter.outcome': 'sent',
    'newsletter.recipientCount': '12',
    'newsletter.error': 'SMTP timed out',
};
//# sourceMappingURL=samples.js.map